import { AdvanceSalaryActions } from "../actions/advanceSalary";
import { AdvanceSalaryDetails } from "../models";

interface AdvanceSalaryPaginationData {
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

export interface AdvanceSalaryState {
  loading: boolean;
  advanceSalaries: AdvanceSalaryDetails;
  paginationData: AdvanceSalaryPaginationData;
}

const defaultPaginationData: AdvanceSalaryPaginationData = {
  page: 1,
  pageSize: 10,
  totalItems: 0,
  totalPages: 0,
};

const defaultState: AdvanceSalaryState = {
  loading: false,
  advanceSalaries: [],
  paginationData: defaultPaginationData,
};

export default function advanceSalaryReducer(
  state = defaultState,
  action: any
): AdvanceSalaryState {
  switch (action.type) {
    case AdvanceSalaryActions.REQUEST_GET_ADVANCE_SALARY:
      return {
        ...state,
        loading: true,
      };
    case `${AdvanceSalaryActions.REQUEST_GET_ADVANCE_SALARY}_SUCCESS`:
      return {
        ...state,
        loading: false,
        advanceSalaries: action.payload.data ?? [],
        paginationData: action.payload.metadata,
      };
    case `${AdvanceSalaryActions.REQUEST_GET_ADVANCE_SALARY}_FAILURE`:
      return {
        ...state,
        loading: false,
        advanceSalaries: [],
        paginationData: defaultPaginationData,
      };

    case AdvanceSalaryActions.SET_PAGE:
      return {
        ...state,
        paginationData: {
          ...state.paginationData,
          page: action.payload.page,
        },
      };

    default:
      return state;
  }
}
